import React from 'react';

class TotalsTableMonthlyRow extends React.Component {

  render() {
  	const {MONTH, MonthEnd, MonthStart, OrderSum, PartnerId, PaymentFees, PointName, TicketQty, Username} = this.props.data;
    const {activecols} = this.props;
    
    return (
      <tr>
        <td>{MonthStart}</td>
        <td>{MonthEnd}</td>
        <td>{TicketQty}</td>
        <td>{OrderSum}</td>
        <td>{PaymentFees}</td>
        {activecols.pointName && <td>{PointName}</td>}
        {activecols.username && <td>{Username}</td>}
      </tr>
    );
  }
}

export default TotalsTableMonthlyRow;
